@use '@lib/assets/styles/main.scss' as *;

.rootPopover {
  [class='ant-popover-container'] {
    background-color: $gray0;
    padding: 16px;
    line-height: 20px;
    font-weight: 500;
    font-size: 14px;
    border-radius: 6px;
    box-shadow: 0 10px 20px 0 rgba($gray1000, 0.16);
    overflow: hidden;
  }
}
